
import React from 'react';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { UseFormReturn } from "react-hook-form";
import { FormValues } from "@/schemas/bilanPatrimoineSchema";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface ProductCategorySectionProps {
  form: UseFormReturn<FormValues>;
}

const ProductCategorySection: React.FC<ProductCategorySectionProps> = ({ form }) => {
  return (
    <FormField
      control={form.control}
      name="productCategory"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Catégorie de produit qui vous intéresse</FormLabel>
          <Select 
            onValueChange={field.onChange} 
            defaultValue={field.value}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Sélectionnez une catégorie" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              <SelectItem value="assurance-vie">Assurance Vie</SelectItem>
              <SelectItem value="immobilier">Investissement Immobilier</SelectItem>
              <SelectItem value="bourse">Marchés Boursiers</SelectItem>
              <SelectItem value="or">Or et Métaux Précieux</SelectItem>
              <SelectItem value="crypto">Cryptomonnaies</SelectItem>
              <SelectItem value="retraite">Préparation Retraite</SelectItem>
              <SelectItem value="fiscalite">Optimisation Fiscale</SelectItem>
              <SelectItem value="succession">Planification Successorale</SelectItem>
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default ProductCategorySection;
